import React, { useState, useEffect, useRef } from "react";
import UsuariosService from '../../service/usuario/index.js';
import styled, { createGlobalStyle } from "styled-components";
import Menu from "../menu/Menu.js";
import Header from "../cabecalho/Cabecalho.js";
import Rodape from "../rodape/Rodape.js";
import Titulo from "../titulo/Titulo.js";
import ModalDesignacao from "./modal/designacao/ModalDesignacao.js";
import ModalExclusao from "./modal/exclusao/ModalExclusao.js";
import ResponsiveDatePicker from "../designacoes/components/ResponsiveDatePicker.js";
import CardNovaDesignacao from './card/CardNovaDesignacao.js';
import CardDesignacoes from './card/CardDesignacoes.js';
import { chavePeriodoDoRotulo, opcoesDeHorarioDoPonto } from './horariosPonto.js';
import { EstadoCarregando } from '../home/tabela/EstadosTabela.js';

const TORRE_DE_TV_REGION_ID = '685dfd5798e2136844fde981';

const DesignacaoItemSpan = styled.span.attrs({ className: 'designacao-item-title' })``;
const DesignacaoItemCheckbox = styled.input.attrs({ className: 'designacao-item-checkbox' })``;
const DesignacaoItemLabel = styled.p.attrs({ className: 'designacao-item-label' })``;
const DesignacaoItemPublicador = styled.p.attrs({ className: 'publicador designacao-item-publicador' })``;
const DesignacaoItemCongregacao = styled.p.attrs({ className: 'designacao-item-congregacao' })``;
const DesignacaoItemData = styled.p.attrs({ className: 'designacao-item-data' })``;
const DesignacaoItemPeriodos = styled.p.attrs({ className: 'periodos designacao-item-periodos' })``;
const DesignacaoItemActions = styled.div.attrs({ className: 'actions designacao-item-actions' })``;
const DesignacaoItemExtra = styled.p.attrs({ className: 'extra designacao-item-extra' })``;

const PageWrapper = styled.div.attrs({ className: 'page-wrapper' })`
  display: flex;
  flex-direction: column;
  /* Ocupa toda a viewport */
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div.attrs({ className: 'main-content-wrapper' })`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  /* Garante que o conteúdo não ultrapasse verticalmente */
  min-height: 0;
  /* Compensa o header fixo (85px) e o footer fixo (50px) */
  margin-top: 85px;
  margin-bottom: 50px;
`;

const Container = styled.div.attrs({ className: 'container' })`
  flex: 1;
  overflow-y: auto;
  /* Reserva o espaço do menu lateral fixo (240px total) + gutter */
  margin-left: 240px;
  padding: clamp(1rem, 2vh, 1.5rem) clamp(1rem, 2.5vw, 2rem);
  box-sizing: border-box;
  /* Importante: o menu é fixo e não colapsa; manter o offset em todas as larguras
     para evitar que o conteúdo passe por baixo dele quando os cards empilham. */

  @media (max-width: 1200px) {
    margin-left: 60px;
    padding-left: 20px;
  }

  @media (max-width: 767.98px) {
    margin-left: 0;
    padding-left: clamp(1rem, 4vw, 2rem);
  }
`;

const Content = styled.main.attrs({ className: 'content' })`
  padding: 0;
  display: flex;
  flex-direction: column;
  /* Ocupa toda a altura disponível */
  width: 100%;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  align-items: stretch; 
  gap: clamp(0.75rem, 2vw, 1rem);
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1200px) {
    margin: 0;
    max-width: none;
    width: 100%;
  }

  @media (max-width: 768px) {
    /* Em empilhado: permitir que o conteúdo cresça e role verticalmente */
    height: auto;
    overflow: visible;
  }
`;

const BlocoTituloCards = styled.div.attrs({ className: 'bloco-titulo-cards' })`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* Dá um pouco mais de respiro vertical acima/entre os cards */
  gap: clamp(0.75rem, 1.6vh, 1rem);
  /* Ocupa o espaço restante e permite scroll interno */
  flex: 1;
  min-height: 0;
  overflow: hidden;
  transition: margin .2s ease;

  @media (max-width: 768px) {
    /* Em empilhado: permitir crescimento e scroll na página */
    overflow: visible;
    flex: none;
  }
`;

const PageTitleWrapper = styled.div.attrs({ className: 'page-title-wrapper' })`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  /* Subimos o conjunto reduzindo o padding superior em ~2px */
  padding-top: clamp(0.375rem, 0.8vh, 0.75rem);
`;

const ExcluirButton = styled.button.attrs({ className: 'excluir-button' })`
  background-color: #008080;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap; 

  &:hover {
    background-color: #006666;
  }
`;

const MensagemExclusao = styled.div`
  background-color: #fee;
  color: #c33;
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 16px;
  border: 1px solid #fcc;
  font-family: 'Roboto', sans-serif;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

const CardsWrapper = styled.div.attrs({ className: 'cards-wrapper' })`
  /* Duas colunas que empilham no mobile, centralizadas */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: clamp(1rem, 2.5vw, 1.5rem);
  row-gap: clamp(1.1rem, 3vw, 1.75rem);
  width: 100%;
  /* Ocupa o espaço restante vertical disponível */
  flex: 1;
  min-height: 0;
  overflow: hidden;
  /* Força altura igual para todos os cards */
  grid-auto-rows: 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    /* Em 1 coluna, deixamos as linhas dimensionarem pelo conteúdo */
    grid-auto-rows: auto;
    /* Permitir que os cards empilhados sejam visíveis com scroll na página */
    overflow: visible;
    flex: none;
  }
`;

const Card = styled.div.attrs({ className: 'card' })`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  /* Largura e altura 100% dentro da célula da grid */
  width: 100%;
  height: 100%;
  /* Altura máxima com margem extra e viewport estável (100dvh) para eliminar qualquer sobreposição */
  max-height: calc(100dvh - 85px - 50px - 7rem);
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    /* Empilhado: queremos o dobro da altura útil para dar mais respiro
       e o scroll passa a ser na página/conteúdo principal, não dentro do card */
    max-height: none;
    height: auto;
    min-height: 0;
  }
`;

const CardHeader = styled.div.attrs({ className: 'card-header' })`
  background: #00aaaa;
  color: #f1f7f9;
  padding: 9px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 16px;
  font-weight: 500;

  @media (max-width: 560px) {
    font-size: clamp(15px, 4vw, 18px);
    padding: 12px 16px;
  }
`;

const CardBody = styled.div.attrs({ className: 'card-body' })`
  padding: clamp(0.75rem, 2vw, 1.25rem) clamp(1rem, 3vw, 2rem);
  display: flex;
  flex-direction: column;
  gap: 7px;
  /* Permite scroll interno e garante que o conteúdo não ultrapasse */
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  @media (max-width: 768px) {
    /* Empilhado: sem scroll interno; o scroll fica no container/página */
    overflow-y: visible;
  }
`;

const FormGroup = styled.div.attrs({ className: 'form-group' })`
  display: flex;
  flex-direction: row; /* labels ao lado esquerdo */
  align-items: center;
  width: 100%;

  label {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    width: 70px; /* largura fixa para alinhar os campos */
    text-align: left;
    flex-shrink: 0;
  }

  input,
  select {
    padding: 6px 14px;
    border: 1px solid #c5c5c5;
    border-radius: 18px;
    font-size: 13px;
    /* Flexível para ajustar ao card */
    flex: 1;
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;

    label {
      width: auto;
      margin-bottom: 0.5rem;
      font-size: clamp(14px, 3.5vw, 15px);
    }

    input,
    select {
      width: 100%;
      max-width: none;
      font-size: clamp(14px, 3.5vw, 16px);
      padding: 10px 16px;
    }
  }
`;


const CampoBase = styled.input.attrs({ className: 'campo-base' })`
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #c5c5c5;
  border-radius: 18px;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  background: #fff;
  outline: none;
  transition: border-color .2s, box-shadow .2s;

  box-sizing: border-box;

  &:focus {
    border-color: #008080;
    box-shadow: 0 0 0 2px rgba(0,128,128,0.15);
  }
  &::placeholder { color:#999; }

  @media (max-width: 560px) {
    font-size: clamp(14px, 3.5vw, 16px);
    padding: 10px 16px;
  }
`;

const CampoInput = styled(CampoBase).attrs({ as: 'input', className: 'campo-input' })``;

const CampoSelect = styled(CampoBase).attrs({ as: 'select', className: 'campo-select' })`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23008080" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  flex: none;
`;

const CampoDateWrapper = styled.div.attrs({ className: 'campo-date-wrapper' })`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: none;
  width: 100%;
  max-width: none;
`;

const PeriodoWrapper = styled.div.attrs({ className: 'periodo-wrapper' })`
  display: grid;
  grid-template-columns: 70px 1fr; 
  row-gap: 8px;
  column-gap: 8px;
  margin-top: 5px;
  align-items: flex-start;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const PeriodoLabel = styled.div.attrs({ className: 'periodo-label' })`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  line-height: 28px;

  @media (max-width: 560px) {
    display: none;
  }
`;

const PeriodoRow = styled.div.attrs({ className: 'periodo-row' })`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;

  span {
    width: 55px;
    font-weight: 500;
    font-size: 13px;
    text-align: left;
  }

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    span {
      width: auto;
      font-size: clamp(14px, 3.5vw, 16px);
      margin-bottom: 4px;
      font-weight: 600;
    }
  }
`;

const TimeButton = styled.button.attrs({ className: 'time-button' })`
  background-color: #e0e0e0;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;

  &.selected { background-color: #008080; color: #fff; }

  @media (max-width: 560px) {
    width: 100%;
    padding: 10px;
    font-size: 13px;
  }
`;

const AddButton = styled.button.attrs({ className: 'add-button' })`
  background-color: #008080;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 7px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  width: 60%;
  align-self: center; 

  &:hover { background-color: #006666; }

  @media (max-width: 560px) {
    width: 100%;
    padding: 12px;
    font-size: clamp(15px, 3.8vw, 17px);
  }
`;

const PublicadorTable = styled.table.attrs({ className: 'publicador-table' })`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 5px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding-bottom: 1%;

  @media (max-width: 560px) {
    font-size: 12px;
  }
`;

const PublicadorThead = styled.thead.attrs({ className: 'publicador-thead' })``;
const PublicadorTbody = styled.tbody.attrs({ className: 'publicador-tbody' })``;
const PublicadorTr = styled.tr.attrs({ className: 'publicador-tr' })``;
const PublicadorTh = styled.th.attrs({ className: 'publicador-th' })`
  font-size: 13px;
  padding: 10px 12px;
  background: #00aaaa;
  color: #fff;
  font-weight: 500;
  text-align: left;
  border-top: none;
  border-bottom: 1px solid #00aaaa;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
    text-align: right;
  }

  @media (max-width: 560px) {
    font-size: 11px;
    padding: 8px 6px;
  }
`;
const PublicadorTd = styled.td.attrs({ className: 'publicador-td' })`
  font-size: 13px;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
  &:last-child {
    text-align: right;
  }

  @media (max-width: 560px) {
    font-size: 11px;
    padding: 8px 6px;
    word-break: break-word;
  }
`;

const CheckboxWrapper = styled.div.attrs({ className: 'checkbox-wrapper' })`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;

  label { font-size: 13px; }
`;

const GravarButton = styled.button.attrs({ className: 'gravar-button' })`
  background-color: #008080;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  width: 25%;

  &:hover { background-color: #006666; }

  @media (max-width: 560px) {
    width: 100%;
    padding: 12px;
    font-size: clamp(15px, 3.8vw, 17px);
  }
`;

const CancelarButton = styled.button.attrs({ className: 'cancelar-button' })`
  background-color: #e0e0e0;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  width: 25%;
  font-weight: 500;

  &:hover {
    background-color: #c4c4c4;
  }

  @media (max-width: 560px) {
    width: 100%;
    padding: 12px;
    font-size: clamp(15px, 3.8vw, 17px);
  }
`;

const DesignacaoItem = styled.div.attrs({ className: 'designacao-item' })`
  border: 1px solid #eee;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;

const DesignacaoItemHeader = styled.div.attrs({ className: 'designacao-item-header' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: #008080;
  font-size: 18px;
  margin-bottom: 8px;
`;

const DesignacaoItemBody = styled.div.attrs({ className: 'designacao-item-body' })`
  background: #f9f9f9;
  border-radius: 12px;
  padding: 14px 16px 10px 16px;
  margin-bottom: 0;
  position: relative;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
  border: 1px solid #eee;

  p {
    margin: 0 0 5px 0;
    font-size: 14px;
    color: #444;
  }
  p.publicador {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 2px;
  }
  p.periodos {
    font-weight: bold;
    color: #008080;
    font-size: 15px;
    margin-bottom: 2px;
  }
  .actions {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column; 
    align-items: center;
    gap: 8px;
  }
  .extra {
    font-size: 13px;
    color: #666;
    margin-top: 6px;
  }
`;

const DesignacaoActions = styled.div.attrs({ className: 'designacao-actions' })`
  display: flex;
  gap: 12px;
  align-items: center;
  .icon { cursor: pointer; color: #888; font-size: 20px; }
  .icon:hover { color: #333; }
`;


const CampoDatePicker = ResponsiveDatePicker;


const Designacoes = () => {
  const containerRef = useRef(null);
  const isUserInteraction = useRef(false);
  const [dataDesignacao, setDataDesignacao] = useState(null);
  const [periodos, setPeriodos] = useState({ manha: [], tarde: [], noite: [] });
  const [modalOpen, setModalOpen] = useState(false);
  const [pontos, setPontos] = useState([]);
  const [pontoSelecionado, setPontoSelecionado] = useState("");
  const [regioes, setRegioes] = useState([]);
  const [regiaoSelecionada, setRegiaoSelecionada] = useState("");
  const [usarFiltroCoordenador, setUsarFiltroCoordenador] = useState(true);
  const [publicadoresSelecionados, setPublicadoresSelecionados] = useState([]);
  const [publicadoresSemDisponibilidade, setPublicadoresSemDisponibilidade] = useState([]);
  const [perfilUsuario, setPerfilUsuario] = useState([]);
  const [publicadoresSemDisponibilidadeHorario, setPublicadoresSemDisponibilidadeHorario] = useState([]);
  const [disponibilidadesCache, setDisponibilidadesCache] = useState(null);
  const [errors, setErrors] = useState({ ponto: '', data: '', publicadores: '', periodo: '', msgHorario: '', msgHorarioIds: [], msgData: '', msgDataIds: [] });
  const [mensagemConflito, setMensagemConflito] = useState('');
  const [designacoes, setDesignacoes] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [selectedDesignacoes, setSelectedDesignacoes] = useState([]);
  const [modalExclusaoOpen, setModalExclusaoOpen] = useState(false);
  const [exclusaoTarget, setExclusaoTarget] = useState(null); // string id or array of ids
  const [mensagemExclusao, setMensagemExclusao] = useState('');
  const [designacaoEmEdicao, setDesignacaoEmEdicao] = useState(null);
  const [loadingDesignacoes, setLoadingDesignacoes] = useState(true);
  const [hasLoadedDesignacoes, setHasLoadedDesignacoes] = useState(false);
  const [perfilCarregado, setPerfilCarregado] = useState(false);

  const handleUserInteraction = () => {
    isUserInteraction.current = true;
  };

  const handleSelectPublicador = (selecionados) => {
    handleUserInteraction();
    setPublicadoresSelecionados(prev => {
      const isArray = Array.isArray(selecionados);
      const itemsToAdd = isArray ? selecionados : [selecionados];
      
      const next = [...prev];
      itemsToAdd.forEach(pub => {
        if (!next.some(p => p._id === pub._id)) {
          next.push(pub);
        }
      });
      setErrors(prevE => ({ ...prevE, publicadores: next.length >= 2 ? '' : prevE.publicadores }));
      return next;
    });
    setModalOpen(false);
  };

  const isPontoInTorreDeTV = (pontoId) => {
    const p = pontos.find(pt => String(pt._id) === String(pontoId));
    if (!p) return false;
    const rId = p.regiao?._id || p.regiao;
    return String(rId) === TORRE_DE_TV_REGION_ID;
  };

  const checkPontoMatch = (dispPontoId, targetPontoId) => {
    if (String(dispPontoId) === String(targetPontoId)) return true;
    if (isPontoInTorreDeTV(targetPontoId) && isPontoInTorreDeTV(dispPontoId)) {
      return true;
    }
    return false;
  };

  const validarDisponibilidade = async (pontoIdAtual, periodosAtuais = periodos, dataAtual = dataDesignacao, pubsSelecionados = publicadoresSelecionados) => {
    // Não validar se estamos apenas carregando dados de edição (sem interação do usuário)
    if (!isUserInteraction.current && editandoId) {
      return { msgPonto: '', msgHorario: '' };
    }

    if (!pubsSelecionados || pubsSelecionados.length === 0) {
      setPublicadoresSemDisponibilidade([]);
      setPublicadoresSemDisponibilidadeHorario([]);
      return { msgPonto: '', msgHorario: '' };
    }
    try {
      let lista = disponibilidadesCache;
      if (!lista) {
        const dispModule = await import("../../service/disponibilidade/index.js");
        lista = await dispModule.default.getDisponibilidades();
        setDisponibilidadesCache(lista);
      }
      const horariosSelecionados = [
        ...periodosAtuais.manha,
        ...periodosAtuais.tarde,
        ...periodosAtuais.noite
      ];

      let diaNorm = null;
      if (dataAtual instanceof Date) {
        const nomes = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
        const diaSelecionado = nomes[dataAtual.getDay()];
        diaNorm = (diaSelecionado || '').toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      }
      const norm = s => (s || '').toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      const dispFiltradaBase = lista.filter(d => {
        if (diaNorm && norm(d.dia) !== diaNorm) return false;
        if (pontoIdAtual) {
          const dispPonto = d.ponto?._id || d.ponto;
          if (!checkPontoMatch(dispPonto, pontoIdAtual)) return false;
        }
        return true;
      });

      let semDispPonto = [];
      if (pontoIdAtual) {
        const dispFiltradaPorPonto = lista.filter(d => {
          const dispPonto = d.ponto?._id || d.ponto;
          return checkPontoMatch(dispPonto, pontoIdAtual);
        });
        semDispPonto = pubsSelecionados.filter(pub => !dispFiltradaPorPonto.some(d => String(d.usuario?._id || d.usuario) === String(pub._id))).map(p => p._id);
      }

      let semDispData = [];
      if (dataAtual instanceof Date) {
        const diaNormCheck = diaNorm;

        semDispData = pubsSelecionados.filter(pub => {
          // Busca disponibilidades do publicador apenas para o dia da semana e ponto
          const temDisponibilidadeNoDia = lista.some(d => {
            // Mesmo usuário
            if (String(d.usuario?._id || d.usuario) !== String(pub._id)) return false;
            // Mesmo dia da semana
            if (!diaNormCheck || norm(d.dia) !== diaNormCheck) return false;
            // Mesmo ponto
            if (pontoIdAtual) {
              const dispPonto = d.ponto?._id || d.ponto;
              if (!checkPontoMatch(dispPonto, pontoIdAtual)) return false;
            }
            return true;
          });

          // Se não há nenhuma disponibilidade válida para o DIA (independente da semana), marca como sem disponibilidade
          return !temDisponibilidadeNoDia;
        }).map(p => p._id);
      }
      let semDispHorario = [];
      if (horariosSelecionados.length > 0) {
        pubsSelecionados.forEach(pub => {
          const dispDoUsuario = dispFiltradaBase.filter(d => String(d.usuario?._id || d.usuario) === String(pub._id));
          // Se o publicador tem disponibilidade para o dia/ponto, verifica os horários
          if (dispDoUsuario.length > 0) {
            const horariosDisponiveis = new Set();
            dispDoUsuario.forEach(d => d.horario.forEach(h => horariosDisponiveis.add(h)));
            const temTodos = horariosSelecionados.every(h => horariosDisponiveis.has(h));
            if (!temTodos) semDispHorario.push(pub._id);
          } else {
            // Se não tem disponibilidade nenhuma para o dia/ponto, também marca como sem horário disponível
            semDispHorario.push(pub._id);
          }
        });
      }
      setPublicadoresSemDisponibilidade(semDispPonto);
      setPublicadoresSemDisponibilidadeHorario(semDispHorario);
      let msgPonto = '';
      if (semDispPonto.length > 0) {
        const nomes = pubsSelecionados.filter(p => semDispPonto.includes(p._id)).map(p => p.nome || p._id);
        msgPonto = `Os seguintes publicadores não possuem disponibilidade para o ponto selecionado: ${nomes.join(', ')}.`;
      }
      let msgHorario = '';
      let msgHorarioDetalhes = [];
      if (semDispHorario.length > 0) {
        const pubsComFaltantes = pubsSelecionados.filter(p => semDispHorario.includes(p._id));
        const detalhes = pubsComFaltantes.map(pub => {
          const dispDoUsuario = dispFiltradaBase.filter(d => String(d.usuario?._id || d.usuario) === String(pub._id));
          const horariosDisponiveis = new Set();
          dispDoUsuario.forEach(d => (d.horario || []).forEach(h => horariosDisponiveis.add(h)));
          // Identifica todos os horários selecionados que o publicador NÃO tem disponibilidade
          const faltantes = horariosSelecionados.filter(h => !horariosDisponiveis.has(h));
          return { id: pub._id, nome: pub.nome || pub._id, faltantes };
        });
        msgHorarioDetalhes = detalhes;
        // Define mensagem genérica de erro para impedir salvamento
        msgHorario = 'Publicadores com indisponibilidade de horário.';
      }

      setErrors(prev => {
        const next = { ...prev, msgHorario, msgHorarioIds: semDispHorario, msgHorarioDetalhes, msgData: '', msgDataIds: [] };
        if (msgPonto) next.publicadores = msgPonto; // somente sobrescreve quando há mensagem de ponto
        if (semDispData.length > 0) {
          next.msgDataIds = semDispData;
        }

        if (msgHorario) {
          next.periodo = msgHorario;
        } else if (next.periodo && next.periodo !== 'Selecione ao menos um horário.') {
          next.periodo = '';
        }
        return next;
      });
      return { msgPonto, msgHorario, semDispHorario };
    } catch (e) {
      setPublicadoresSemDisponibilidade([]);
      setPublicadoresSemDisponibilidadeHorario([]);
      setErrors(prev => ({ ...prev, msgHorario: '', msgHorarioIds: [] }));
      return { msgPonto: '', msgHorario: '' };
    }
  };

  const getWeekOfMonth = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
    return Math.floor((date.getDate() - 1) / 7) + 1;
  };

  const getOccurrencesInMonth = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return [];
    const year = date.getFullYear();
    const month = date.getMonth();
    const weekday = date.getDay();
    const occurrences = [];
    const firstOccurrence = new Date(year, month, 1);
    while (firstOccurrence.getDay() !== weekday) {
      firstOccurrence.setDate(firstOccurrence.getDate() + 1);
      if (firstOccurrence.getMonth() !== month) return [];
    }
    for (let current = new Date(firstOccurrence); current.getMonth() === month; current.setDate(current.getDate() + 7)) {
      occurrences.push({ date: new Date(current), week: getWeekOfMonth(current) });
    }
    return occurrences;
  };

  const createWeekSet = (values = []) => new Set(values.filter(week => typeof week === 'number' && !Number.isNaN(week)));

  const normalizeFrequencyLabel = (frequency) => {
    if (typeof frequency !== 'string' || !frequency.trim()) return 'Todas as semanas do mês';

    const canonicalByKey = {
      'todas as semanas do mes': 'Todas as semanas do mês',
      'todas as semanas': 'Todas as semanas do mês',
      'primeira semana do mes': 'Primeira semana do mês',
      'primeira semana': 'Primeira semana do mês',
      'segunda semana do mes': 'Segunda semana do mês',
      'segunda semana': 'Segunda semana do mês',
      'terceira semana do mes': 'Terceira semana do mês',
      'terceira semana': 'Terceira semana do mês',
      'ultima semana do mes': 'Última semana do mês',
      'ultima semana': 'Última semana do mês',
      'duas primeiras semanas do mes': 'Duas primeiras semanas do mês',
      'duas primeiras semanas': 'Duas primeiras semanas do mês',
      'duas ultimas semanas do mes': 'Duas últimas semanas do mês',
      'duas ultimas semanas': 'Duas últimas semanas do mês'
    };

    const key = frequency
      .trim()
      .replace(/\s+/g, ' ')
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase();

    const keyWithoutApenas = key.replace(/^apenas\s+(a\s+)?/, '');
    return canonicalByKey[keyWithoutApenas] || canonicalByKey[key] || frequency.trim();
  };

  const getAllowedWeeksForFrequency = (frequency = 'Todas as semanas do mês', occurrences = []) => {
    if (!Array.isArray(occurrences) || occurrences.length === 0) return new Set();
    const weeks = occurrences.map(o => o.week).filter(w => typeof w === 'number');
    if (weeks.length === 0) return new Set();
    const frequencyNormalized = normalizeFrequencyLabel(frequency);
    switch (frequencyNormalized) {
      case 'Primeira semana do mês':
        return createWeekSet([weeks[0]]);
      case 'Segunda semana do mês':
        return createWeekSet([weeks[1] ?? weeks[0]]);
      case 'Terceira semana do mês':
        return createWeekSet([weeks[2] ?? weeks[weeks.length - 1]]);
      case 'Última semana do mês':
        return createWeekSet([weeks[weeks.length - 1]]);
      case 'Duas primeiras semanas do mês':
        return createWeekSet(weeks.slice(0, Math.min(2, weeks.length)));
      case 'Duas últimas semanas do mês':
        return createWeekSet(weeks.slice(-Math.min(2, weeks.length)));
      case 'Todas as semanas do mês':
      default:
        return createWeekSet(weeks);
    }
  };

  const normalize = (s) => (s || '').toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();

  const validarDisponibilidadeSemana = async (data, pubs = publicadoresSelecionados) => {
    try {
      // Não validar se estamos apenas carregando dados de edição
      if (!isUserInteraction.current && editandoId) {
        return [];
      }

      if (!data || !(data instanceof Date) || Number.isNaN(data.getTime())) return [];
      if (!pontoSelecionado) return [];
      if (!Array.isArray(pubs) || pubs.length === 0) return [];

      let lista = disponibilidadesCache;
      if (!lista) {
        const dispModule = await import("../../service/disponibilidade/index.js");
        lista = await dispModule.default.getDisponibilidades();
        setDisponibilidadesCache(lista);
      }

      const diaNorm = ['domingo','segunda','terca','quarta','quinta','sexta','sabado'][data.getDay()];
      const ocorrencias = getOccurrencesInMonth(data);
      const semanaAtual = getWeekOfMonth(data);

      const resultado = [];
      
      const horariosSelecionados = [
        ...periodos.manha,
        ...periodos.tarde,
        ...periodos.noite
      ];

      pubs.forEach(pub => {
        const dispDoUsuario = (lista || []).filter(d => {
          const usuarioId = d?.usuario?._id || d?.usuario;
          if (String(usuarioId) !== String(pub._id)) return false;

          const pontoId = d?.ponto?._id || d?.ponto;
          if (!checkPontoMatch(pontoId, pontoSelecionado)) return false;

          if (normalize(d.dia) !== normalize(diaNorm)) return false;

          // Para semana do mês, basta ter disponibilidade cadastrada
          // naquele dia e ponto; não exigimos sobreposição exata de horário.
          return true;
        });

        const horariosIndisponiveis = [];

        if (horariosSelecionados.length > 0) {
          horariosSelecionados.forEach(horario => {
            const coberto = dispDoUsuario.some(d => {
              const temHorario = d.horario && d.horario.includes(horario);
              if (!temHorario) return false;

              const frequencia = normalizeFrequencyLabel(d.frequencia);
              const semanasPermitidas = getAllowedWeeksForFrequency(frequencia, ocorrencias);
              if (semanasPermitidas.size === 0) return false;
              return semanasPermitidas.has(semanaAtual);
            });
            
            if (!coberto) horariosIndisponiveis.push(horario);
          });

          if (horariosIndisponiveis.length > 0) {
            resultado.push({ id: pub._id, horarios: horariosIndisponiveis });
          }
        } else {
          // verifica se alguma disponibilidade do usuário é válida para a semana atual
          const possuiNaSemana = dispDoUsuario.some(d => {
            const frequencia = normalizeFrequencyLabel(d.frequencia);
            const semanasPermitidas = getAllowedWeeksForFrequency(frequencia, ocorrencias);
            if (semanasPermitidas.size === 0) return false;
            return semanasPermitidas.has(semanaAtual);
          });

          if (!possuiNaSemana) resultado.push({ id: pub._id, horarios: [] });
        }
      });

      return resultado;
    } catch (e) {
      console.error('Erro em validarDisponibilidadeSemana:', e);
      return [];
    }
  };

  const handleChangePonto = async (novoPontoId) => {
    handleUserInteraction();
    setPontoSelecionado(novoPontoId);
    setErrors(prev => ({ ...prev, ponto: '' }));

    const novoPonto = pontos.find(p => String(p._id) === String(novoPontoId));
    if (novoPonto) {
      const permitidas = opcoesDeHorarioDoPonto(novoPonto);
      setPeriodos(prev => ({
        manha: prev.manha.filter(h => permitidas.manha.includes(h)),
        tarde: prev.tarde.filter(h => permitidas.tarde.includes(h)),
        noite: prev.noite.filter(h => permitidas.noite.includes(h))
      }));
    }

    if (!novoPontoId) {
      setErrors(prev => ({ ...prev, publicadores: '' }));
      setPublicadoresSemDisponibilidade([]);
      setPublicadoresSemDisponibilidadeHorario([]);
      return '';
    }

    // Só valida se houver interação do usuário ou não estiver em modo de edição
    if (isUserInteraction.current || !editandoId) {
      const { msgPonto } = await validarDisponibilidade(novoPontoId);
      return msgPonto;
    }
    return '';
  };

  useEffect(() => {
    // Não executa validação se estamos carregando dados de edição
    if (!isUserInteraction.current && editandoId) return;
    
    // Só valida se todos os campos básicos estiverem preenchidos
    if (pontoSelecionado && dataDesignacao && publicadoresSelecionados.length > 0) {
      validarDisponibilidade(pontoSelecionado);
    }
  }, [periodos, dataDesignacao, publicadoresSelecionados, pontoSelecionado]);

  useEffect(() => {
    if (!perfilCarregado) return; // Aguarda perfil antes de carregar
    async function fetchDesignacoes() {
      setLoadingDesignacoes(true);
      try {
        const designacaoApi = await import("../../service/designacao/index.js");
        const lista = await designacaoApi.default.getDesignacoes(usarFiltroCoordenador);
        const usuarioId = localStorage.getItem('idUsuario');
        const isAdmin = perfilUsuario.includes && (perfilUsuario.includes('admin') || perfilUsuario.includes('coordenador-geral'));
        let filtradas = lista || [];
        if (!isAdmin) {
          if (!usarFiltroCoordenador && usuarioId) {
            filtradas = (lista || []).filter(des => {
              if (!usuarioId) return true; 
              const ponto = des.ponto;
              const coords = ponto && ponto.coordenadores ? ponto.coordenadores : [];
              return coords.some(c => {
                if (!c) return false;
                if (typeof c === 'string') return String(c) === String(usuarioId);
                if (c._id) return String(c._id) === String(usuarioId);
                return false;
              });
            });
          }
        }
        const sorted = filtradas.slice().sort((a, b) => {
          const da = a && a.data ? new Date(a.data) : new Date(0);
          const db = b && b.data ? new Date(b.data) : new Date(0);
          return db - da;
        });
        setDesignacoes(sorted);
        setHasLoadedDesignacoes(true);
      } catch (error) {
        setDesignacoes([]);
        setHasLoadedDesignacoes(true);
      } finally {
        setLoadingDesignacoes(false);
      }
    }
    async function fetchPontos() {
      try {
        const pontosApi = await import("../../service/pontos/index.js");
        const lista = await pontosApi.default.getPontos(usarFiltroCoordenador);
        const usuarioId = localStorage.getItem('idUsuario');
        const isAdmin = perfilUsuario.includes && (perfilUsuario.includes('admin') || perfilUsuario.includes('coordenador-geral'));
        let filtrados = lista;
        if (!isAdmin) {
          if (!usarFiltroCoordenador && usuarioId) {
            filtrados = (lista || []).filter(p => {
              const coords = p && p.coordenadores ? p.coordenadores : [];
              return coords.some(c => {
                if (!c) return false;
                if (typeof c === 'string') return String(c) === String(usuarioId);
                if (c._id) return String(c._id) === String(usuarioId);
                return false;
              });
            });
            if (filtrados.length > 0) {
              const regioesIds = new Set(filtrados.map(p => (p.regiao && (p.regiao._id || p.regiao))).filter(Boolean).map(x => String(x)));
              filtrados = lista.filter(p => regioesIds.has(String(p.regiao && (p.regiao._id || p.regiao))));
            }
          }
        }
        setPontos(filtrados);
        return filtrados;
      } catch (error) {
        setPontos([]);
        return [];
      }
    }
    async function fetchRegioes(pontosData = pontos) {
      try {
        const regioesApi = await import("../../service/regioes/index.js");
        const lista = await regioesApi.default.getRegioes(usarFiltroCoordenador);
        const isAdmin = perfilUsuario.includes && (perfilUsuario.includes('admin') || perfilUsuario.includes('coordenador-geral'));
        let filtradas = lista;
        if (!usarFiltroCoordenador && !isAdmin) {
          const pontosRef = pontosData && pontosData.length ? pontosData : [];
          if (pontosRef.length) {
            const regioesIds = new Set(pontosRef.map(p => (p.regiao && (p.regiao._id || p.regiao))).filter(Boolean).map(x => String(x)));
            filtradas = (lista || []).filter(r => regioesIds.has(String(r._id)));
          }
        }

        setRegioes(filtradas);
        if ((!regiaoSelecionada || regiaoSelecionada === '') && filtradas && filtradas.length === 1) {
          setRegiaoSelecionada(String(filtradas[0]._id));
        }
      } catch (error) {
        setRegioes([]);
      }
    }
    
    const loadData = async () => {
      const pontosData = await fetchPontos();
      await fetchRegioes(pontosData);
      await fetchDesignacoes();
    };
    loadData();
  }, [usarFiltroCoordenador, perfilUsuario, perfilCarregado]);

  useEffect(() => {
    const id = (typeof window !== 'undefined') ? localStorage.getItem('idUsuario') : null;
    if (!id) { setPerfilCarregado(true); return; }
    UsuariosService.getUsuarioById(id)
      .then(u => {
        const perfis = (u && Array.isArray(u.perfil)) ? u.perfil : [];
        setPerfilUsuario(perfis);
        if (perfis.includes('admin') || perfis.includes('coordenador-geral')) {
          setUsarFiltroCoordenador(false);
        }
      })
      .catch(() => { })
      .finally(() => setPerfilCarregado(true));
  }, []);

  useEffect(() => {
    const verificarConflitos = async () => {
      // Não verifica conflitos se estamos carregando dados de edição
      if (!isUserInteraction.current && editandoId) {
        setMensagemConflito('');
        return;
      }

      if (!publicadoresSelecionados || publicadoresSelecionados.length === 0 || !dataDesignacao) {
        setMensagemConflito('');
        return;
      }

      const horariosSelecionados = [
        ...periodos.manha,
        ...periodos.tarde,
        ...periodos.noite
      ];

      if (horariosSelecionados.length === 0) {
        setMensagemConflito('');
        return;
      }

      // Se não há interação do usuário ainda, não faz a verificação
      if (!isUserInteraction.current) {
        return;
      }

      try {
        const designacaoApi = await import("../../service/designacao/index.js");
        const publicadorIds = publicadoresSelecionados.map(p => p._id);

        // Se estamos editando e os dados são iguais aos originais, não verifica conflito
        if (editandoId && designacaoEmEdicao) {
          const isSameData = dataDesignacao && new Date(dataDesignacao).toISOString().split('T')[0] === new Date(designacaoEmEdicao.data).toISOString().split('T')[0];
          const currentPubIds = publicadorIds.slice().sort().join(',');
          const originalPubIds = (designacaoEmEdicao.publicadores || []).map(p => p._id).slice().sort().join(',');
          const currentHorarios = horariosSelecionados.slice().sort().join(',');
          const originalHorarios = (designacaoEmEdicao.horario || []).slice().sort().join(',');

          if (isSameData && currentPubIds === originalPubIds && currentHorarios === originalHorarios) {
            setMensagemConflito('');
            return;
          }
        }

        const resultado = await designacaoApi.default.verificarConflito(publicadorIds, dataDesignacao, horariosSelecionados, editandoId);
        
        if (resultado && resultado.conflito) {
          setMensagemConflito(resultado.mensagem);
        } else {
          setMensagemConflito('');
        }
      } catch (error) {
        console.error('Erro ao verificar conflito:', error);
        setMensagemConflito('');
      }
    };

    // Debounce para evitar chamadas excessivas à API
    const timeoutId = setTimeout(verificarConflitos, 500);
    return () => clearTimeout(timeoutId);
  }, [publicadoresSelecionados, dataDesignacao, periodos, editandoId, designacaoEmEdicao]);

  const togglePeriodo = (periodo, valor) => {
    handleUserInteraction();
    setMensagemConflito('');
    setPeriodos(prev => {
      const jaSelecionado = prev[periodo].includes(valor);
      return {
        ...prev,
        [periodo]: jaSelecionado
          ? prev[periodo].filter(v => v !== valor)
          : [...prev[periodo], valor]
      };
    });
  };

  const horarioJaIniciadoHoje = (data, horario) => {
    if (!(data instanceof Date) || Number.isNaN(data.getTime()) || typeof horario !== 'string') {
      return false;
    }

    const agora = new Date();
    const mesmaData = (
      data.getFullYear() === agora.getFullYear() &&
      data.getMonth() === agora.getMonth() &&
      data.getDate() === agora.getDate()
    );

    if (!mesmaData) {
      return false;
    }

    const [horaInicioTexto] = horario.split('-');
    const horaInicio = Number.parseInt(horaInicioTexto, 10);
    if (Number.isNaN(horaInicio)) {
      return false;
    }

    const inicioHorario = new Date(
      agora.getFullYear(),
      agora.getMonth(),
      agora.getDate(),
      horaInicio,
      0,
      0,
      0
    );

    return agora >= inicioHorario;
  };

  const formatDate = (d) => {
    if (!d) return "";
    try {
      const dt = new Date(d);
      return dt.toLocaleDateString('pt-BR');
    } catch (e) {
      return String(d);
    }
  };

  const handleGravar = async () => {
    // Marca que é uma ação intencional do usuário
    handleUserInteraction();
    
    const newErrors = { ponto: '', data: '', publicadores: '', periodo: '', conflito: '' };
    if (!pontoSelecionado) newErrors.ponto = 'Selecione um ponto';
    if (!dataDesignacao) newErrors.data = 'Selecione uma data.';
    else {
      try {
        const hoje = new Date();
        const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        const dt = new Date(dataDesignacao.getFullYear(), dataDesignacao.getMonth(), dataDesignacao.getDate());
        if (dt < hojeSemHora) {
          newErrors.data = 'A data selecionada não pode ser anterior à data atual.';
        }
      } catch (e) {  }
    }
    const horariosTodos = [...periodos.manha, ...periodos.tarde, ...periodos.noite];
    if (horariosTodos.length === 0) newErrors.periodo = 'Selecione ao menos um horário.';
    if (!newErrors.data && horariosTodos.some((horario) => horarioJaIniciadoHoje(dataDesignacao, horario))) {
      newErrors.periodo = 'Os horários já iniciados hoje não podem mais ser utilizados.';
    }
    if (!publicadoresSelecionados || publicadoresSelecionados.length < 2) newErrors.publicadores = 'Adicione pelo menos dois publicadores.';
    setErrors(newErrors);
    if (newErrors.ponto || newErrors.data || newErrors.publicadores || newErrors.periodo) return;

    const horarios = [
      ...periodos.manha,
      ...periodos.tarde,
      ...periodos.noite
    ];

    const periodoEscolhido = periodos.manha.length ? 'Manhã' : (periodos.tarde.length ? 'Tarde' : (periodos.noite.length ? 'Noite' : ''));

    const payload = {
      ponto: pontoSelecionado,
      publicadores: publicadoresSelecionados.map(p => p._id),
      data: dataDesignacao instanceof Date ? dataDesignacao.toISOString() : dataDesignacao,
      periodo: periodoEscolhido,
      horario: horarios,
      atualizadoPor: localStorage.getItem('idUsuario')
    };

    if (!editandoId) {
      payload.criadoPor = localStorage.getItem('idUsuario');
    }

    try {
      const designacaoApi = await import("../../service/designacao/index.js");
      if (editandoId) {
        const updated = await designacaoApi.default.updateDesignacao(editandoId, payload);
        const pontoObj = pontos.find(p => String(p._id) === String(pontoSelecionado)) || (updated.ponto || null);
        const displayUpdated = {
          ...updated,
          ponto: pontoObj,
          publicadores: publicadoresSelecionados && publicadoresSelecionados.length > 0 ? publicadoresSelecionados : (updated.publicadores || [])
        };
        
        setDesignacoes(prev => [displayUpdated, ...prev.filter(d => d._id !== displayUpdated._id)]);
      } else {
        const created = await designacaoApi.default.createDesignacao(payload);
        const pontoObj = pontos.find(p => String(p._id) === String(pontoSelecionado)) || (created.ponto || null);
        const displayCreated = {
          ...created,
          ponto: pontoObj,
          publicadores: publicadoresSelecionados && publicadoresSelecionados.length > 0 ? publicadoresSelecionados : (created.publicadores || [])
        };
        setDesignacoes(prev => [displayCreated, ...prev.filter(d => d._id !== displayCreated._id)]);
      }

      setDataDesignacao(null);
      setPeriodos({ manha: [], tarde: [], noite: [] });
      setPublicadoresSelecionados([]);
      setPontoSelecionado("");
      setRegiaoSelecionada("");
      setModalOpen(false);
      setEditandoId(null);
      setMensagemConflito('');
      setErrors({ ponto: '', data: '', publicadores: '', msgHorario: '', msgHorarioIds: [], msgData: '', msgDataIds: [], conflito: '' });
      setDesignacaoEmEdicao(null);
      } catch (error) {
        console.error('Erro ao gravar designação', error);

        let mensagemErro = 'Ocorreu um erro inesperado.';
        
        if (error.response && error.response.data && error.response.data.detalhes) {
            mensagemErro = error.response.data.detalhes;
        } else if (error.message) {
            mensagemErro = error.message;
        }

        // Apenas substitui mensagens técnicas quando não vieram detalhes da API
        if (mensagemErro.includes('Request failed with status code') || mensagemErro.includes('Network Error')) {
          mensagemErro = 'Não foi possível gravar a designação. Tente novamente ou entre em contato com o suporte.';
        }
        
        setErrors(prev => ({
          ...prev,
          conflito: mensagemErro
        }));
      }
  };

  const handleCancelarEdicao = () => {
    setEditandoId(null);
    setDesignacaoEmEdicao(null);
    setDataDesignacao(null);
    setPeriodos({ manha: [], tarde: [], noite: [] });
    setPublicadoresSelecionados([]);
    setPontoSelecionado("");
    setRegiaoSelecionada("");
    setMensagemConflito('');
    setPublicadoresSemDisponibilidade([]);
    setPublicadoresSemDisponibilidadeHorario([]);
    setErrors({ ponto: '', data: '', publicadores: '', periodo: '', msgHorario: '', msgHorarioIds: [], msgData: '', msgDataIds: [], conflito: '' });
  };

  const handleExcluirDesignacao = async (id) => {
    setExclusaoTarget(id);
    setModalExclusaoOpen(true);
  };

  const handleEditarDesignacao = (des) => {
    isUserInteraction.current = false;
    setErrors({ ponto: '', data: '', publicadores: '', periodo: '', msgHorario: '', msgHorarioIds: [], msgData: '', msgDataIds: [], conflito: '' });
    setMensagemConflito('');
    setPublicadoresSemDisponibilidade([]);
    setPublicadoresSemDisponibilidadeHorario([]);
    setEditandoId(des._id);
    setDesignacaoEmEdicao(des);
    try {
      const dt = des.data ? new Date(des.data) : null;
      setDataDesignacao(dt);
    } catch { setDataDesignacao(null); }

    const horarios = des.horario || [];
    const manha = horarios.filter(h => chavePeriodoDoRotulo(h) === 'manha');
    const tarde = horarios.filter(h => chavePeriodoDoRotulo(h) === 'tarde');
    const noite = horarios.filter(h => chavePeriodoDoRotulo(h) === 'noite');
    setPeriodos({ manha, tarde, noite });
    setPontoSelecionado(des.ponto?._id || '');
    setRegiaoSelecionada('');
    setPublicadoresSelecionados(des.publicadores || []);
    setTimeout(() => {
      containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  const toggleSelectDesignacao = (id) => {
    setSelectedDesignacoes(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleExcluirSelecionados = async () => {
    if (!selectedDesignacoes || selectedDesignacoes.length === 0) {
      setMensagemExclusao('Selecione ao menos uma designação para excluir.');
      setTimeout(() => setMensagemExclusao(''), 5000);
      return;
    }
   
    setMensagemExclusao('');
    setExclusaoTarget([...selectedDesignacoes]);
    setModalExclusaoOpen(true);
  };

  const confirmExcluir = async () => {
    if (!exclusaoTarget) return setModalExclusaoOpen(false);
    try {
      const designacaoApi = await import("../../service/designacao/index.js");
      if (Array.isArray(exclusaoTarget)) {
        const promises = exclusaoTarget.map(id => designacaoApi.default.deleteDesignacao(id).then(() => ({ id, status: 'fulfilled' })).catch(err => ({ id, status: 'rejected', reason: err })));
        const results = await Promise.all(promises);
        const rejected = results.filter(r => r.status === 'rejected');
        const deletedIds = results.filter(r => r.status === 'fulfilled').map(r => r.id);
        setDesignacoes(prev => prev.filter(d => !deletedIds.includes(d._id)));
        setSelectedDesignacoes([]);
        if (editandoId && deletedIds.includes(editandoId)) {
          setEditandoId(null);
          setDataDesignacao(null);
          setPeriodos({ manha: [], tarde: [], noite: [] });
          setPublicadoresSelecionados([]);
          setPontoSelecionado("");
          setRegiaoSelecionada("");
        }
        if (rejected.length > 0) {
          console.error('Algumas exclusões falharam', rejected);
          const mensagem = rejected.length === 1 
            ? '1 exclusão falhou. Veja console para detalhes.' 
            : `${rejected.length} exclusões falharam. Veja console para detalhes.`;
          setMensagemExclusao(mensagem);
          setTimeout(() => setMensagemExclusao(''), 5000);
        }
      } else {
        await designacaoApi.default.deleteDesignacao(exclusaoTarget);
        setDesignacoes(prev => prev.filter(d => d._id !== exclusaoTarget));
        if (editandoId === exclusaoTarget) {
          setEditandoId(null);
          setDesignacaoEmEdicao(null);
          setDataDesignacao(null);
          setPeriodos({ manha: [], tarde: [], noite: [] });
          setPublicadoresSelecionados([]);
          setPontoSelecionado("");
          setRegiaoSelecionada("");
        }
      }
    } catch (e) {
      console.error(e);
      setMensagemExclusao('Erro ao excluir designações: ' + (e.message || e));
      setTimeout(() => setMensagemExclusao(''), 5000);
    } finally {
      setExclusaoTarget(null);
      setModalExclusaoOpen(false);
    }
  };
  return (
    <PageWrapper>
      <Header />
      <MainContentWrapper>
        <Menu />
        <Container ref={containerRef}>
          <Content>
            <BlocoTituloCards>
              <PageTitleWrapper>
                <Titulo>Designações</Titulo>
                <ExcluirButton onClick={handleExcluirSelecionados}>{selectedDesignacoes.length ? `Excluir (${selectedDesignacoes.length})` : 'Excluir'}</ExcluirButton>
              </PageTitleWrapper>
              {mensagemExclusao && <MensagemExclusao>{mensagemExclusao}</MensagemExclusao>}
              <CardsWrapper>
                <CardNovaDesignacao
                  styles={{
                    Card,
                    CardHeader,
                    CardBody,
                    FormGroup,
                    CampoDateWrapper,
                    CampoDatePicker,
                    CampoSelect,
                    PeriodoWrapper,
                    PeriodoLabel,
                    PeriodoRow,
                    TimeButton,
                    AddButton,
                    PublicadorTable,
                    PublicadorThead,
                    PublicadorTbody,
                    PublicadorTr,
                    PublicadorTh,
                    PublicadorTd,
                    CheckboxWrapper,
                    GravarButton,
                    CancelarButton
                  }}
                  dataDesignacao={dataDesignacao}
                  setDataDesignacao={(val) => { handleUserInteraction(); setDataDesignacao(val); }}
                  periodos={periodos}
                  togglePeriodo={togglePeriodo}
                  setModalOpen={setModalOpen}
                  publicadoresSelecionados={publicadoresSelecionados}
                  setPublicadoresSelecionados={(val) => { handleUserInteraction(); setPublicadoresSelecionados(val); }}
                  pontos={pontos}
                  pontoSelecionado={pontoSelecionado}
                  setPontoSelecionado={setPontoSelecionado}
                  regioes={regioes}
                  regiaoSelecionada={regiaoSelecionada}
                  setRegiaoSelecionada={(val) => { handleUserInteraction(); setRegiaoSelecionada(val); }}
                  errors={errors}
                  setErrors={setErrors}
                  handleGravar={handleGravar}
                  editandoId={editandoId}
                  handleChangePonto={handleChangePonto}
                  setEditandoId={setEditandoId}
                  handleCancelarEdicao={handleCancelarEdicao}
                  publicadoresSemDisponibilidade={publicadoresSemDisponibilidade}
                  perfilUsuario={perfilUsuario}
                  mensagemConflito={mensagemConflito}
                  validarDisponibilidadeSemana={validarDisponibilidadeSemana}
                  validarDisponibilidade={validarDisponibilidade}
                  handleUserInteraction={handleUserInteraction}
                />
                <CardDesignacoes
                  styles={{
                    Card,
                    CardHeader,
                    CardBody,
                    DesignacaoItem,
                    DesignacaoItemHeader,
                    DesignacaoItemSpan,
                    DesignacaoItemCheckbox,
                    DesignacaoItemBody,
                    DesignacaoItemLabel,
                    DesignacaoItemPublicador,
                    DesignacaoItemCongregacao,
                    DesignacaoItemData,
                    DesignacaoItemPeriodos,
                    DesignacaoItemActions,
                    DesignacaoItemExtra
                  }}
                  designacoes={designacoes}
                  loading={loadingDesignacoes}
                  hasLoaded={hasLoadedDesignacoes}
                  perfilCarregado={perfilCarregado}
                  selectedDesignacoes={selectedDesignacoes}
                  toggleSelectDesignacao={toggleSelectDesignacao}
                  formatDate={formatDate}
                  handleExcluirDesignacao={handleExcluirDesignacao}
                  handleEditarDesignacao={handleEditarDesignacao}
                />
              </CardsWrapper>
            </BlocoTituloCards>
            <ModalDesignacao
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              onSelectPublicador={handleSelectPublicador}
              horariosSelecionados={[
                ...periodos.manha,
                ...periodos.tarde,
                ...periodos.noite
              ]}
              pontoSelecionado={pontos.find(p => p._id === pontoSelecionado) || null}
              diaSelecionado={dataDesignacao ? ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'][dataDesignacao.getDay()] : null}
              dataSelecionada={dataDesignacao}
              key={`${modalOpen}-${pontoSelecionado}-${(dataDesignacao && dataDesignacao.toISOString ? dataDesignacao.toISOString() : dataDesignacao) || ''}`}
            />
            <ModalExclusao
              open={modalExclusaoOpen}
              onClose={() => { setModalExclusaoOpen(false); setExclusaoTarget(null); }}
              onConfirm={confirmExcluir}
              count={Array.isArray(exclusaoTarget) ? exclusaoTarget.length : 1}
            />
          </Content>
        </Container>
      </MainContentWrapper>
      <Rodape />
    </PageWrapper>
  );
};

export default Designacoes;
